import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rrp-activity-widget',
  templateUrl: './activity-widget.component.html',
  styleUrls: ['./activity-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [NgClass, TranslateModule],
})
export class ActivityWidgetComponent {
  @Input() public type: 'active' | 'offline' | 'inactive' = 'active';

  @Input({ required: true }) public count = 0;
}
